import type { ProfitabilityMissingDefaultShippingCost } from '../models/Profitability';

export function formatDefaultShippingServiceLabel(input: {
  courierName?: string | null;
  courierServiceId: number;
  courierServiceCode?: string | null;
  courierServiceDescription?: string | null;
}): string {
  const courierName = input.courierName?.trim();
  const code = input.courierServiceCode?.trim();
  const description = input.courierServiceDescription?.trim();
  const servicePart = description || code || `#${input.courierServiceId}`;

  if (courierName) return `${courierName} — ${servicePart}`;
  if (code && description) return `${code} — ${description}`;
  return servicePart;
}

export function formatMissingDefaultShippingServiceLabel(row: ProfitabilityMissingDefaultShippingCost): string {
  return formatDefaultShippingServiceLabel({
    courierName: row.courier?.name,
    courierServiceId: row.courier_service_id,
    courierServiceCode: row.courier_service_code,
    courierServiceDescription: row.courier_service_description,
  });
}
